<pbc-filter [config]="BerichtsVorlagenFilterConfig" [filter]="berichtsVorlagen.filter$ | async" (filterChange)="berichtsVorlagen.filter$.next($event)"></pbc-filter>
